export class Logger {
    static _packageInfo(name: string, version: string, appEnv: string, nodeEnv: string, background: string, color: string) {
        console.log(
            `%c${name} v${version} - ENVIRONMENT: ${appEnv} - BUILD_TYPE: ${nodeEnv}`,
            `background: ${background || '#1e518d'}; color: ${color || 'white'}; font-size:12px; padding: 5px;`
        )
    }
}
